import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid } from "@mui/material";

function AlertDialog({
  isVisible = false,
  setIsVisible,
  title,
  content,
  client_id,
  trip_id,
  handleTrip,
}) {
  const [open, setOpen] = useState(isVisible);

  const handleConfirm = (event) => {
    handleTrip(event);
    setIsVisible(false);
    setOpen(false);
  };

  const handleCancel = () => {
    setIsVisible(false);
    setOpen(false);
  };

  return (
    <div>
      {/* Dialog that is displayed if the state open is true */}
      <Dialog
        open={open || isVisible}
        onClose={handleCancel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent={"flex-end"} spacing={1}>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                data-client_id={client_id}
                data-trip_id={trip_id}
                onClick={(event) => handleConfirm(event)}
                autoFocus
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDialog;
